var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrokeIconPop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3971 10.9837L26.8957 11.6757L27.7446 11.7738C29.8522 12.0173 31.4918 13.815 31.5 15.9964C31.4996 18.3435 29.5947 20.2485 27.2485 20.2485H27.0101H25.8032L26.6565 21.102L26.9545 21.4001C28.6157 23.0616 28.6157 25.7518 26.9545 27.4133C25.333 29.0353 22.72 29.0671 21.0506 27.5041L20.3399 26.8386L20.2131 27.8039C19.9388 29.8925 18.1551 31.5 16 31.5C13.8456 31.5 12.0612 29.8847 11.7868 27.8037L11.6589 26.8334L10.9477 27.5057C9.28877 29.0737 6.6685 29.0368 5.04546 27.4133C3.38435 25.7518 3.38435 23.0616 5.04546 21.4001L5.34349 21.102L6.19677 20.2485H4.98989H4.75146C2.40506 20.2485 0.5 18.3431 0.5 15.9957C0.5 13.8167 2.1459 12.0175 4.25537 11.7738L5.10718 11.6753L4.60198 10.9825C3.3912 9.32199 3.53589 6.99098 5.03694 5.48952C6.65126 3.87478 9.24196 3.83545 10.9113 5.36038L11.7485 6.12517V4.99122V4.75273C11.7485 2.40538 13.6536 0.5 16 0.5C18.3464 0.5 20.2515 2.40538 20.2515 4.75273V4.99122V6.129L21.0896 5.35954C22.7576 3.82824 25.3477 3.87372 26.9631 5.48952C28.455 6.98189 28.6011 9.32205 27.3971 10.9837Z",
    fill: "#90F50F",
    stroke: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeIconPop);
export default __webpack_public_path__ + "static/media/stroke-icon-pop.0219848ea648fe7f20cc9b6598abc9cd.svg";
export { ForwardRef as ReactComponent };